import { render } from "./FibrolyseDiacutanee.vue?vue&type=template&id=b72d5fae&scoped=true"
import script from "./FibrolyseDiacutanee.vue?vue&type=script&lang=js"
export * from "./FibrolyseDiacutanee.vue?vue&type=script&lang=js"

import "./FibrolyseDiacutanee.vue?vue&type=style&index=0&id=b72d5fae&scoped=true&lang=css"

import exportComponent from "/home/angelkiro/Dev/SVPhysio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b72d5fae"]])

export default __exports__